import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditAdminBranch = ({ isOpen, onClose, editFormData, setEditFormData, fetchData }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
        Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.", 
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
      const response = await axios.put(`https://rfs2.infraconsoft.net.in/api/adminBranch_edit/${editFormData.branchCode}`, {
        branchCode : editFormData.branchCode,
        branchName : editFormData.branchName,

      });


      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "updated successfully.",
        });
        onClose();
        fetchData();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "This Name already Exist. Please try Different One.",
        });
      }
    } catch (error) {
      console.error("Error updating category:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Update failed. Please try again.",
      });
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}   >
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
    <button className="close-btn" onClick={onClose}>
      &times;
    </button>
  </div>

        <h3>Edit Branch List</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Branch Code :</label>
                <input type="text" name="branchCode" value={editFormData.branchCode} onChange={handleEditChange} readOnly/>
              </div>
        </div>

        <div className="form-row">
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" name="branchName" value={editFormData.branchName} onChange={handleEditChange} />
              </div>
        </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditAdminBranch;
